import { Container } from "@mui/material";
import { useDynamicQuery } from "../../hooks/useDynamicQuery";
import TableComponent from "../Table";
import { GalacticLoader } from "./GalacticLoader";
import { PageHeader } from "./PageHeader";

interface GenericPageProps {
  title: string;
  subtitle: string;
  parentQuery: string;
  childQuery: string;
  tableFields: any[];
  collapseFields: any[];
}

export const GenericPage = ({
  title,
  subtitle,
  parentQuery,
  childQuery,
  tableFields,
  collapseFields,
}: GenericPageProps) => {
  const { error, loading, data } = useDynamicQuery({
    parentQuery,
    childQuery,
    tableFields,
    collapseFields,
  });

  if (loading)
    return (
      <Container>
        <GalacticLoader />
      </Container>
    );

  if (error)
    return (
      <Container>
        <PageHeader title="Error" />
        <p style={{ color: "red" }}>Error: {error.message}</p>
      </Container>
    );

  return (
    <Container>
      <PageHeader title={title} subtitle={subtitle} />
      <TableComponent data={data} />
    </Container>
  );
};
